import * as api from '../api';
import * as auth from '../auth';
import * as parcels from '../parcels';
import * as survey from '../survey';
import * as ui from '../ui';
import * as modal from '../modal';
import * as reports from '../reports';
import * as bar from '../nav-bar';
import * as maps from '../maps';
import * as search from '../search';
import * as layout from '../layout';
import * as builder from '../layer-builder';
import * as layers from '../layers';
import * as filters from '../filters';
import * as tracking from '../tracking';
import * as timeline from '../timeline';
import * as bootup from './bootup';

const pkgs = [
  api,
  auth,
  parcels,
  survey,
  ui,
  modal,
  reports,
  bar,
  maps,
  search,
  layout,
  builder,
  layers,
  filters,
  tracking,
  timeline,
  bootup,
];

export default pkgs;
